import { Types } from './../Models/UserModel';
import { EnumTypes } from './../Models/EnumTypes/PageEnumTypes';
import { EnumTypes as UserEnumTypes } from './../Models/EnumTypes/UserEnumTypes';
import * as UserActions from 'Redux/Actions/UserActions';
import * as UserConnector from './../Connectors/UserConnector';

export { Types, UserConnector as Connector, EnumTypes, UserEnumTypes, UserActions as Actions };



// WEBPACK FOOTER //
// ./src/Modules/UserModule.ts